<div id="tituloPaginaTransferencia"
  class="app-titulo-pagina visible-xs">
  <span>Paycash</span>
</div>

<div class="col-xs-12 app-banner" style="margin-top: 25px;">
  <img class="hidden-xs" id="bannerTransferencia" src="./assets/img/banners/transferencia.png" alt="Banner">
  <img class="visible-xs" src="../../assets/img/banners/mobile_transferencia.png" alt="Banner Transferência">
</div>

<div class="col-xs-12 text-center app-buttons-transferencia" style="margin-bottom: 150px;">
  <a id="nova-transferencia" class="app-btn-best-v2" *ngIf="transferencias !== undefined && mainService.permissionService.hasPermission('funcionalidade:ted')"
    (click)="mainService.loginService.changeRoute('/transferencias/nova')">
    Bancária
  </a>
  <a id="nova-transferencia-cartao" class="app-btn-best-v2 ml2em" *ngIf="transferencias !== undefined && mainService.permissionService.hasPermission('funcionalidade:ted_cartao')"
    (click)="mainService.loginService.changeRoute('/transferencias/cartao/nova')">
    Entre Cartões
  </a>
  <a id="nova-transferencia-pontos-reais" class="app-btn-best-v2 ml2em"
    (click)="mainService.loginService.changeRoute('/transferencias/pontos/reais')"
   *ngIf="mainService.cartaoService.cartao.produto.bandeira">
    {{ mainService.cartaoService.cartao.produto.nome }}
  </a>
</div>

<div *ngIf="transferencias === undefined" class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<input id="length-tabela-transferencia" type="hidden" value="{{transferencias?.length}}">

<div *ngIf="transferencias !== undefined && transferencias.length > 0" class="table-responsive" style="margin-bottom: 100px;">
  <table class="table table-striped table-hover">
    <thead>
      <tr>
        <th class="hidden-xs">Código</th>
        <th><span class="glyphicon glyphicon-arrow-down"></span>Data</th>
        <th class="hidden-xs">Tipo</th>
        <th class="hidden-xs hidden-sm">Destino da Transferência</th>
        <th>Pontos</th>
        <th class="hidden-xs hidden-sm">Status</th>
        <th class="hidden-lg hidden-md">Detalhes</th>
      </tr>
    </thead>
    <tbody id="tabelaTransferenciaBody">

      <tr *ngFor="let transferencia of transferencias">
        <td class="hidden-xs">{{ transferencia.id }}</td>
        <td>{{ transferencia.solicitacao| dateFormat:'dd/MM/yyyy HH:mm' }}</td>
        <td class="hidden-xs">{{ getTransacaoOrigem(transferencia) }}</td>
        <td class="hidden-xs hidden-sm">{{ getTransferenciaDestino(transferencia) }}</td>
        <td>{{ transferencia.valorPontos }}</td>
        <td class="hidden-xs hidden-sm">{{ transferencia.status }}</td>
        <td class="hidden-lg hidden-md">
          <button (click)="verTransferencia(transferencia)" class="btn btn-default" data-toggle="modal" data-target="#modalTabela">
                        Ver
                    </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>


<!--    Modal tabela-->

<div class="modal fade" tabindex="-1" role="dialog" id="modalTabela" *ngIf="transferenciaSelecionada != undefined">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!--            conteúdo tabela   -->
      <div class="modal-body app-list-modal">
        <dl>
          <dt class="app-list-dt">Código: <span class="app-list-data">{{ transferenciaSelecionada.id }}</span> </dt>
          <dt class="app-list-dt">Data: <span class="app-list-data">{{ transferenciaSelecionada.solicitacao| dateFormat:'dd/MM/yyyy HH:mm' }}</span></dt>
          <dt class="app-list-dt">Tipo: <span class="app-list-data">{{ getTransacaoOrigemModal() }}</span></dt>
          <dt class="app-list-dt">Pontos: <span class="app-list-data">{{ transferenciaSelecionada.valorPontos }}</span></dt>
          <dt class="app-list-dt">Status: <span class="app-list-data">{{ transferenciaSelecionada.status }}</span></dt>
          <dt class="app-list-dt">Destino Transferência: <br/><span class="app-list-data">{{ getTransferenciaDestinoModal() }}</span></dt>
          <dd></dd>
        </dl>
      </div>
      <div class="modal-footer text-center">
        <button type="button" class="btn btn-default" data-dismiss="modal" id="btn-modal-fechar">Fechar</button>
      </div>
    </div>
  </div>
</div>

<!--fim modal tabela    -->


// WEBPACK FOOTER //
// ./src/app/transferencia/transferencia.component.html